"use client";

import { registerImplementation } from "@pamperedchef/datalayer";
import Script from "next/script";

import { getDataLayer, initAnalytics } from "@/app/utilities/analytics";

export interface AnalyticsManagerProps {
	src: string;
}

/**
 * Analytics Manager initializer
 */
export function AnalyticsManager({ src }: AnalyticsManagerProps): JSX.Element {
	return (
		<Script
			src={src}
			onLoad={() => {
				initAnalytics();

				registerImplementation({
					// Safe to assert: onLoad guarantees the script has loaded
					getImplementation: () => getDataLayer()!
				});
			}}
		/>
	);
}
